import ELLA_PICTURE from "./headshots/Co-Chairs/Ella Han - Co-Chair.jpg";
import JASON_PICTURE from "./headshots/Co-Chairs/Jason Khuu - Co-Chair.jpg";
import MADISON_PICTURE from "./headshots/Communications/Madison Fernandez - Vice President.jpg";
import FARHAN_PICTURE from "./headshots/Development/Farhan Mohammed - Vice President.jpg";
import ANDREA_PICTURE from "./headshots/Sponsorship/Andrea Mercieca - Vice President.jpg";
import ANNIE_PICTURE from "./headshots/Advisors/Annie Yang- Advisor.jpg";
import JOHNNY_PICTURE from "./headshots/Advisors/Johnny Libenzon- Advisor.jpg";

import MASSIAH_PICTURE from "./headshots/Sponsorship/Massiah Ahmed - Corporate Relations Associate.jpg";
import MOHAMMAD_PICTURE from "./headshots/Sponsorship/Mohammad Shihabuddin - Corporate Relations Associate.jpg";
import PETER_PICTURE from "./headshots/Sponsorship/Peter Michael Mastrofrancesco - Sponsorship Associate.jpg";
import SALLY_PICTURE from "./headshots/Sponsorship/Sally Zheng - Internal Relations Associate.jpg";

import RUPAN_PICTURE from "./headshots/Operations/Rupan Headshot.jpeg";
import YING_PICTURE from "./headshots/Operations/Ying Ge - Logistics Coordinator.jpg";

const headshots = [
  {
    name: "Madison Fernandez",
    role: "VP Communications",
    image: MADISON_PICTURE,
  },
  {
    name: "Mohammad Shihabuddin",
    role: "Corporate Relations Associate",
    image: MOHAMMAD_PICTURE,
  },
  { name: "Rupan Gill", role: "VP Operations", image: RUPAN_PICTURE },
  { name: "Andrea Mercieca", role: "VP Sponsorship", image: ANDREA_PICTURE },
  { name: "Annie Yang", role: "Advisor", image: ANNIE_PICTURE },
  { name: "Ella Han", role: "Co-Chair", image: ELLA_PICTURE },
  { name: "Jason Khuu", role: "Co-Chair", image: JASON_PICTURE },
  { name: "Johnny Libenzon", role: "Advisor", image: JOHNNY_PICTURE },
  {
    name: "Massiah Ahmed",
    role: "Corporate Relations Associate",
    image: MASSIAH_PICTURE,
  },
  { name: "Farhan Mohammed", role: "VP Development", image: FARHAN_PICTURE },
  {
    name: "Peter Michael Mastrofrancesco",
    role: "Sponsorship Associate.",
    image: PETER_PICTURE,
  },
  {
    name: "Sally Zheng",
    role: "Internal Relations Associate",
    image: SALLY_PICTURE,
  },
  { name: "Ying Ge", role: "Logistics Coordinator", image: YING_PICTURE },
];
export default headshots;
